export var Name = 'product-click';
export var ProductClick = Name;